import React from 'react';
import commonService from 'utils/commonService';
import SliderGame from 'components/SliderGame';
import BgImage from 'components/BgImage';
import { IProps } from './types';

const Slider: React.FC<IProps> = (props) => {
  return (
    <>
      {props.items.length > 0 ? (
        <SliderGame
          name={props.name}
          totalPage={props.items.length}
        >
          {props.items.map((it, index) => (
            <SliderGame.Item key={`game-mobile-item-${index}`}>
              <button type="button" className={'card' + (it.STATUS_MSG.includes('可抽獎') ? '' : ' closed')} key={`game-mobile-${index}`} title={it.TITLE} onClick={() => props.onItemClick(it)}>
                <h2 className="title">{it.TITLE}</h2>
                <div className="poster">
                  <BgImage className="img" keepRatio imageUrl={commonService.convertImageUrl(it.IMAGE_NAME)} />
                </div>
                <div className="status">
                  {props.displayMsg(it.SN, it.STATUS_MSG, true)}
                </div>
              </button>
            </SliderGame.Item>
          ))}
        </SliderGame>
      ) : (
        <div className="swiper empty" />
      )}
    </>

  );
};

export default Slider;
